import React from "react";
import { useHistory } from "react-router-dom";
import URL from "../../../constant/URL";
import A from "../../common/A";

const Stage = ( props ) => {

  const history = useHistory();

  const jumpAiPrediction = () => {
    history.push( `${ URL.QUESTION_INSPECTION.AI_PREDICTION }/${ props.data.stgCd }` );
  };

  return (
    <li>
      <A onClick={ jumpAiPrediction }>
        <div className="sl-calcBox">
          <img src={ `${ props.data.stgImgFilePath }${ props.data.stgImgFileNm }` } alt="" />
        </div>
      </A>
      <div className="sl-txtBox">
        <p className="sl-txtBox_txt">{ props.data.stgNm }</p>
        <p className="sl-txtBox_date">{ props.data.stgCd }</p>
      </div>
    </li>
  );

};

Stage.defaultProps = {
  data : {}
};

export default Stage;
